import Spot from './Spot'
import useSpot from './hooks/useSpot'
/**
 * module index, please access all functionalities through here
 * external facing all features are exported there.
 */
export default Spot // renders spot based on the current state it's in.
export { useSpot } // provides methods, current state and states for interacting with Spot.